module.exports = __webpack_public_path__ + "img/Got_It_partial_light.83ee0d59.png";